import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import { useNavigate } from "react-router";
import Box from "@mui/material/Box";
import logo from "./La_Loutiquebem.svg";
import GestionButton from "./GestionButton";
import PanierButton from "./PanierButton";

export default function Header() {
	const navigate = useNavigate();

	return (
		<AppBar
			color="default"
			position="static"
			sx={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "flex-end",
				flexDirection: "row",
				py: 1,
				pr: 1,
			}}
		>
			<Toolbar
				sx={{ alignItems: "flex-end", pr: 0 }}
				variant="dense"
				onClick={() => navigate("./")}
			>
				<Box
					sx={(theme) => ({
						borderRadius: 0,
						width: 60,
						height: 60,
						[theme.breakpoints.down("sm")]: {
							width: 50,
							height: 50,
						},
					})}
					alt="Logo Laloutiquebem"
					component={"img"}
					src={logo}
				/>
				<Typography
					component="h3"
					variant="titleHeader"
				>
					La Loutiquebem
				</Typography>
			</Toolbar>
			<Toolbar>
				<PanierButton />
				<GestionButton />
			</Toolbar>
		</AppBar>
	);
}
